import Vue from "vue";
import constants from './utils/constants/index'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from 'vant';
import { Notify } from 'vant';
import 'vant/lib/index.css';
import 'vant/lib/icon/local.css';
import VueClipboard from 'vue-clipboard2'
import './assets/css/main.css'
import {post} from './utils/http'
import SvgIcon from "./components/svg-icon";
import hf from './utils/utils'

// 全局注册
Vue.use(Vant);
Vue.use(Notify);
Vue.use(VueClipboard)

Vue.prototype.$constants = constants
Vue.prototype.$post = post
Vue.prototype.$baseURL = constants.BASE_URL
Vue.prototype.$prefix = constants.PREFIX
Vue.prototype.$hf =hf

Vue.component('svg-icon', SvgIcon);

Vue.config.productionTip = false;

// 权限按钮显示
Vue.directive('perm', {
  inserted: (el, binding, vnode) => {
    let code = binding.value
    let perms = store.getters['auth/permissions']
    if (!Array.isArray(code)) {
      if (perms.indexOf(code) === -1) { // 无权限
        el.parentNode.removeChild(el)
      }
    } else {
      let show = false
      for (let i = 0; i < code.length; i++) {
        if (perms.indexOf(code[i]) > -1) { // 只要有一个权限就显示
          show = true
          break
        }
      }
      if (!show) {
        el.parentNode.removeChild(el)
      }
    }
  }
})

window.app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js